module.exports = __webpack_public_path__ + "img/icon-serve4.843e594a.png";